/**
 * Vasim Hayat @ 2/10/2018
 */

export class FnDeviceConstant {
	public static readonly DEVICE_FA_ICONS = {
		'WEB': 'fn-global-web ',
		'ANDROID': 'fn-global-android-line ',
		'MOBILE': 'fn-global-phone-line ',
		'WINDOWSTAB': 'fn-global-windowTablet ',
		'IOS': 'fn-global-ios ',
		'WINDOWS8': 'fn-global-windows8 ',
		'UNKNOWN': 'fn-global-unknown ',
		'APACHECLIENT': 'fn-global-apaceClient ',
		'ANDROIDTAB': 'fn-global-androidTablet ',
		'IPAD': 'fn-global-ipad ',
		'API': 'fn-global-APK ',
		'WEBCLOCK': 'fn-global-webClock '
	};
	public static readonly DEVICE_IMG_ICONS = {
		WEB: 'assets/images/device/WEB.png',
		ANDROID: 'assets/images/device/ANDROID.png',
		MOBILE: 'assets/images/device/mobile.png',
		WINDOWSTAB: 'assets/images/device/WINDOWSTAB.png',
		IOS: 'assets/images/device/IOS.png',
		WINDOWS8: 'assets/images/device/WINDOWS8.png',
		UNKNOWN: 'assets/images/device/UNKNOWN.png',
		APACHECLIENT: 'assets/images/device/APACHECLIENT.png',
		ANDROIDTAB: 'assets/images/device/ANDROIDTAB.png',
		IPAD: 'assets/images/device/Ipad.png',
		API: 'assets/images/device/API.png',
		WEBCLOCK: 'assets/images/zipClock/webClkDevice.png',
	};
	public static readonly DEVICE_APP_ICONS = {
		'1': 'assets/images/logo/headerLogo/zipSchedule.png',
		'2': 'assets/images/logo/headerLogo/zipclock.png',
		'3': 'assets/images/logo/headerLogo/ZipChecklist.png',
		'4': 'assets/images/logo/headerLogo/fpreport.png',
		'5': 'assets/images/logo/headerLogo/shiftBook.png',
		'6': 'assets/images/logo/headerLogo/zipForecast.png',
		'14': 'assets/images/logo/headerLogo/zip_ordering.svg',
		'8': 'assets/images/logo/headerLogo/Zip-Supplier-logo.png',
		'9': 'assets/images/logo/headerLogo/ZipAutogas_Icon_150.png',
		'10': 'assets/images/logo/headerLogo/ZipReporting_Icon_150.png',
		'11': 'assets/images/logo/headerLogo/ZipHaccp-logo.svg',
		'12': 'assets/images/logo/headerLogo/anyconnector_logo.svg',
		'13': 'assets/images/logo/headerLogo/zip_inventory.svg',
		'15': 'assets/images/logo/headerLogo/zip-temperature3.svg',
		'50': 'assets/images/logo/headerLogo/zip_inventory.svg',
	};

	public static readonly DEVICE_COLOR_MAP = {
		ANDROID: 'green',
		WINDOWS8: 'blue',
		IPAD: 'blue',
		UNKNOWN: 'gray',
	};
}
